<template>
  <div class="multiselect__wrapper">
    <label class="typo__label">
      Entity
      <sup>*</sup>
    </label>
    <multiselect
      id="batch-file-entity"
      v-model="entity"
      :required="true"
      :show-labels="false"
      :options="getMultiselectOptions"
      placeholder="Choose related entity please"
      :class="[!isEntityGuidValid ? 'invalidField' : '']"
      :close-on-select="true"
      :allow-empty="false"
      track-by="value"
      label="text"
      @select="sendSelectedValueToParent"
    >
      <span slot="noResult">
        Oops! No elements found. Consider changing the search query.
      </span>
    </multiselect>
    <span
      v-if="!isEntityGuidValid"
      class="error__message"
    >
      This field is required
    </span>
  </div>
</template>
<script>

import {createNamespacedHelpers} from 'vuex';

const {
  mapState: sidebarMapState,
} = createNamespacedHelpers('sidebar');

const {
  mapState: fileManipulationMapState,
  mapActions: fileManipulationMapActions,
} = createNamespacedHelpers('fileManipulationController');
export default {
  name: 'EntitiesMultiselect',
  props: [
    'batchFile',
    'isEditMode',
    'isBatchFileModal',
    'isEntityGuidValid',
  ],
  data() {
    return {
      entity: {text: '', value: null},
      isTouched: false,
    };
  },
  watch: {
    tablesList: {
      handler(val) {
        if (!val) return;
        if (this.isEditMode && this.batchFile) {
          this.entity = {
            text: val[this.batchFile.enitiyGuid].label,
            value: this.batchFile.entityGuid,
          };
        } else {
          this.entity = {
            text: null,
            value: null,
          };
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...sidebarMapState({
      tablesList: state => state.tablesList,
    }),
    ...fileManipulationMapState({
      editSheetConfig: state => state.addEditSheetConfigModal.data,
    }),
    getMultiselectOptions() {
      if (!Object.values(this.tablesList).length) return;
      return Object.values(this.tablesList).map(el => ({
        value: el.entityGuid,
        text: el.label,
      }));
    },
  },
  methods: {
    ...fileManipulationMapActions(['setEntityToBatchFile']),
    sendSelectedValueToParent() {
      this.isBatchFileModal
        ? this.setEntityToBatchFile(this.entity)
        : this.$emit('get-value-on-select', this.entity);
    },
  },
  mounted() {
    if (this.isEditMode && !this.isBatchFileModal) {
      this.entity = this.editSheetConfig.currentEntry.entityGuid;
    }
  },
};
</script>

<style lang="scss">
.multiselect__wrapper {
  margin-top: 10px;
}

.multiselect.invalidField {
  & .multiselect__tags {
    border: 1px solid red !important;
  }
}

.error__message {
  position: absolute;
  color: red;
  transform: translateY(-15%);
  font-size: 10px;
}
</style>
